import { SVGProps } from 'react'

export const RatingDescriptionArrow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="326"
      height="6"
      viewBox="0 0 326 6"
      fill="none"
      {...props}
    >
      <path
        d="M0 3L5 5.88675L5 0.113249L0 3ZM326 3L321 0.113249V5.88675L326 3ZM4.5 3V3.5L321.5 3.5V3V2.5L4.5 2.5V3Z"
        fill="#4F556B"
        fillOpacity="0.4"
      />
    </svg>
  )
}
